import { SvgIconType } from './svg.interface';

const Pharmacy: SvgIconType = ({
  width = 12,
  height = 13,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 2.65H9.71L10.375 0.766003L9.00417 0.25L8.1525 2.65H0.75V3.85L1.91667 7.45L0.75 11.05V12.25H11.25V11.05L10.0833 7.45L11.25 3.85V2.65ZM8.33309 8.05034H6.58308V9.85034H5.41642V8.05034H3.66641V6.85034H5.41642V5.05033H6.58308V6.85034H8.33309V8.05034Z"
      fill={color}
    />
  </svg>
);

export default Pharmacy;
